module.exports = __webpack_public_path__ + "static/media/Michael S. Dukakis - 1988.f8901979.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Michael S. Dukakis - 1988.jpg
// module id = 533
// module chunks = 0